import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO, PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL2, SERVICES } from "../../lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0E2A56] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Journey's Handyman Services logo" className="h-20 w-auto object-contain bg-white rounded-lg p-1.5" />
          </div>
          <p className="mt-4 text-white/70 leading-relaxed max-w-sm">
            Your trusted local handyman, remodeling and emergency restoration team serving
            Blairsville, GA and a 50-mile radius across North Georgia and North Carolina.
          </p>
        </div>

        <div>
          <h3 className="font-heading text-lg font-bold uppercase tracking-wide text-[#C8102E]">Services</h3>
          <ul className="mt-4 space-y-2 text-white/80">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <a href="#services" className="hover:text-white transition-colors">{s.title}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-lg font-bold uppercase tracking-wide text-[#C8102E]">Contact</h3>
          <ul className="mt-4 space-y-4 text-white/80">
            <li>
              <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors">
                <Phone className="h-5 w-5 text-[#C8102E]" strokeWidth={2.5} /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors break-all">
                <Mail className="h-5 w-5 text-[#C8102E] shrink-0" strokeWidth={2.5} /> {EMAIL}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL2}`} data-testid="footer-email-2" className="flex items-center gap-3 hover:text-white transition-colors break-all">
                <Mail className="h-5 w-5 text-[#C8102E] shrink-0" strokeWidth={2.5} /> {EMAIL2}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-5 w-5 text-[#C8102E] shrink-0" strokeWidth={2.5} /> Blairsville, GA 30512
            </li>
          </ul>
          <a href={`tel:${PHONE_TEL}`} className="mt-6 inline-flex items-center gap-2 bg-[#C8102E] hover:bg-[#9E0C24] text-white font-heading font-bold uppercase tracking-wide px-5 py-3 transition-colors">
            <Phone className="h-5 w-5" strokeWidth={2.5} /> Free Quote
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-6 text-center text-white/50 text-sm">
          © {new Date().getFullYear()} Journey's Handyman Services LLC · Blairsville, GA ·
          Serving North Georgia & North Carolina
          <a href="/dashboard" data-testid="owner-login-link" className="ml-2 text-white/40 hover:text-[#C8102E] transition-colors">· Owner Login</a>
        </div>
      </div>
    </footer>
  );
};
